var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServe2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 44,
    rx: 22,
    fill: "#EAFFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14C19.5817 14 16 17.5817 16 22C16 26.4183 19.5817 30 24 30C28.4183 30 32 26.4183 32 22C32 21.5446 31.962 21.0988 31.8893 20.6655C31.798 20.1208 32.1654 19.6052 32.7101 19.5138C33.2548 19.4224 33.7704 19.7899 33.8618 20.3345C33.9528 20.8768 34 21.4333 34 22C34 27.5228 29.5228 32 24 32C18.4772 32 14 27.5228 14 22C14 16.4772 18.4772 12 24 12C25.5947 12 27.1049 12.374 28.445 13.04C28.9396 13.2858 29.1413 13.886 28.8955 14.3806C28.6497 14.8751 28.0495 15.0768 27.555 14.831C26.4852 14.2994 25.279 14 24 14Z",
    fill: "#2F945C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 13C32.5523 13 33 13.4477 33 14V15H34C34.5523 15 35 15.4477 35 16C35 16.5523 34.5523 17 34 17H33V18C33 18.5523 32.5523 19 32 19C31.4477 19 31 18.5523 31 18V17H30C29.4477 17 29 16.5523 29 16C29 15.4477 29.4477 15 30 15H31V14C31 13.4477 31.4477 13 32 13Z",
    fill: "#2F945C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2929 25.2929C21.6834 24.9024 22.3166 24.9024 22.7071 25.2929C23.4212 26.0069 24.5788 26.0069 25.2929 25.2929C25.6834 24.9024 26.3166 24.9024 26.7071 25.2929C27.0976 25.6834 27.0976 26.3166 26.7071 26.7071C25.212 28.2022 22.788 28.2022 21.2929 26.7071C20.9024 26.3166 20.9024 25.6834 21.2929 25.2929Z",
    fill: "#2F945C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 19.5C22.2 18.6716 21.5284 18 20.7 18C19.8716 18 19.2 18.6716 19.2 19.5C19.2 20.3284 19.8716 21 20.7 21C21.5284 21 22.2 20.3284 22.2 19.5Z",
    fill: "#2F945C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3 18C28.1284 18 28.8 18.6716 28.8 19.5C28.8 20.3284 28.1284 21 27.3 21C26.4716 21 25.8 20.3284 25.8 19.5C25.8 18.6716 26.4716 18 27.3 18Z",
    fill: "#2F945C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServe2);
export default __webpack_public_path__ + "static/media/serve2.22e0ad3528fbe3f3c90ae67fbfd94089.svg";
export { ForwardRef as ReactComponent };